import { FC } from 'react';
import Card from 'components/UI/Card';
import CardHeader from 'components/UI/Card/CardHeader';
import { Title } from 'components/UI/Card/CardHeader/styled';

type ErrorCardProps = {
  route: string;
  navTitle: string;
  title: string;
  errorMessage: string;
};

const ErrorCard: FC<ErrorCardProps> = ({
  route,
  navTitle,
  title,
  errorMessage,
}) => {
  return (
    <Card>
      <CardHeader navUrl={route} title={navTitle} />
      <Title>{title}</Title>
      {errorMessage}
    </Card>
  );
};

export default ErrorCard;
